export default __webpack_public_path__ + "static/Screenshot3-253418cf4372077cb9beaee20c102147.jpg";